import React, { useState } from "react";
import { Button, Col, Row, Spinner } from "react-bootstrap";
import { FaFilePdf, FaPlay, FaSearch, FaSwimmingPool, FaTicketAlt } from "react-icons/fa";
import { TbCoins, TbTruckDelivery } from "react-icons/tb";
import { TiCancel, TiWarningOutline } from "react-icons/ti";
import { useNavigate } from "react-router-dom";
import PrivateApi from "../../services/PrivateApiService";
import { useAuthState } from "../../context/AuthContext";
import PdfModal from "../../components/shared/PdfModal";

/**
 * 
 * @param {left} props bool to position item left if true
 * @param {elv} props bool if elv
 * @param {endElv} props bool if elv end 
 * @param {futureEndElv} props bool if elv ends in future
 * @param {poolrechnung} props bool if poolrechnung
 * @param {abrechnung} props bool if abrechnung
 * @param {vorschreibung} props bool if vorschreibung
 * @param {storno} props bool if storno
 * @param {mahnung} props bool if mahnung
 * @param {ticket} props bool if ticket
 * @param {data} props object item data
 * {type, data, position, future}, 
 */
const TimelineItem = ({type, data, left, future, endinvoice}) => {

    const { user } = useAuthState();
    const API = new PrivateApi();
    const [downloadLoading, setDownloadLoading] = useState(false);

    // pdf viewer
    const [readingLoading, setReadingLoading] = useState(false);
    const [pdfModal, setPdfModal] = useState(false);
    const [pdfFile, setPdfFile] = useState("");



    // * color schemes
    var bg = '#404040';
    var color = 'white';
    var opacity = 1;
    var border = "border-dark";
    var icon = <FaPlay className="text-dark" size={40} />;
    var headerText = "";
    var iconDate = "";
    var leftColumnText = false;
    var rightColumnText = false;
    var secondRowLeftText = false;
    var secondRowRightText = false;
    var thirdRowLeftText = false;
    var thirdRowRightText = false;


    if (type === "elvstart") {
        headerText = "Beginn Energieliefervertrag";
        leftColumnText = <p className="text-energo">{data.x_energieprodukt_id[1]}</p>
        secondRowLeftText = <><b>Belieferungsbeginn</b><p>{new Date(data.x_belbeg).toLocaleDateString('DE-de')}</p></>
        secondRowRightText = <><b>Vertragsende</b><p>{new Date(data.x_datum_vertragsende).toLocaleDateString('DE-de')}</p></>
        thirdRowLeftText = <a href={user.x_is_house_management? `/hw/dashboard/energieliefervertraege/${data.id}`:`/dashboard/energieliefervertraege/${data.id}`} className="link-energo"><FaSearch/> Energieliefervertrag ansehen</a>;

        if (data.x_file_auftragsbestaetigung_name !== "False") {
            thirdRowRightText = <Button onClick={() => download()} className="btn-energo"><FaFilePdf /> Auftragsbestätigung</Button>
        }
    }
    if (type === "elvend") {
        headerText = "Ende Energieliefervertrag"
        leftColumnText = <p className="text-energo">{data.x_energieprodukt_id[1]}</p>
        secondRowLeftText = <><b>Vertragsende</b><p>{data.x_datum_vertragsende !== "False"? new Date(data.x_datum_vertragsende).toLocaleDateString('DE-de') : "offenes Vertragsende"}</p></>
        if (endinvoice[0] !== undefined) {
            secondRowRightText = <Button onClick={() => download(endinvoice[0].id)} className="btn-energo"><FaFilePdf /> Endabrechnung</Button>
        }
    }

    if (type === 'poolrechnung') { 
        bg = '#a2c13f'; 
        border = 'border-energo'; 
        icon = <FaSwimmingPool className="text-energo" size={40} />;
        headerText = `ENERGO ${data.x_rechnungsart}`;
        iconDate = new Date(data.x_rechnungsdatum).toLocaleDateString('DE-de');
        leftColumnText = <><b>Rechnungsnummer</b><p>{data.x_rechnungsnummer}</p></>
        rightColumnText = <><b>Rechnungsart</b><p>{data.x_rechnungsart}</p></>
        secondRowLeftText = <><b>Rechnungsdatum</b><p>{new Date(data.x_rechnungsdatum).toLocaleDateString('DE-de')}</p></>
        secondRowRightText = <><b>{data.x_poolbeitrag_summe_lastschrift >= 0? "Summe Lastschrift":"Summe Gutschrift"}</b><p>{Number(data.x_poolbeitrag_summe_lastschrift).toFixed(2)} €</p></>
        thirdRowLeftText = <a href="ansehen/poolrechnung/" onClick={(e) => {e.preventDefault(); openPdf()}} className="link-energo text-light"><FaSearch /> ansehen</a>
        thirdRowRightText = <Button className="btn-dark" onClick={() => download()}><FaFilePdf /> Download</Button>
    }
    if (type === 'abrechnung') {
        bg = "#0d6efd"; 
        border = 'border-primary';
        icon = <TbTruckDelivery className="text-primary" size={40} />
        headerText = "Energielieferant Abrechnung";
        iconDate = new Date(data.x_eingangsdatum).toLocaleDateString('DE-de');
        leftColumnText = <><b>Rechnungsdatum</b><p>{new Date(data.x_eingangsdatum).toLocaleDateString('DE-de')}</p></>
        rightColumnText = <><b>Abrechnungszeitraum</b><p>{new Date(data.x_abrechnungszeitraum_von).toLocaleDateString('DE-de')} - {new Date(data.x_abrechnungszeitraum_bis).toLocaleDateString('DE-de')}</p></>
        secondRowLeftText = <><b>Verbrauch gesamt</b><p>{data.x_verbrauch_gesamt} kWh</p></>
        secondRowRightText = <><b>Energiekosten netto</b><p>{Number(data.x_energiekosten_netto).toFixed(2)} €</p></>
        thirdRowLeftText = <a href="ansehen/abrechnung/" onClick={(e) => {e.preventDefault(); openPdf()}} className="link-energo text-light"><FaSearch /> ansehen</a>
        thirdRowRightText = <Button className="btn-dark" onClick={() => download()}><FaFilePdf /> Download</Button>
    }
    if (type === 'vorschreibung') {
        bg = '#ffc107'; 
        color = "black"; 
        border = 'border-warning';
        icon = <TbCoins className="text-warning" size={40} /> ;
        headerText = "Energielieferant Vorschreibung";
        iconDate = new Date(data.create_date).toLocaleDateString('DE-de');
        leftColumnText = <><b>Rechnungsdatum</b><p>{new Date(data.create_date).toLocaleDateString('DE-de')}</p></>
        rightColumnText = <><b>Teilvorschreibung brutto</b><p>{Number(data.x_teilvorschreibung_brutto).toFixed(2)} €</p></>
        thirdRowLeftText = <a href="ansehen/vorschreibung/" onClick={(e) => {e.preventDefault(); openPdf()}} className="link-energo text-dark"><FaSearch /> ansehen</a>
        thirdRowRightText = <Button className="btn-dark" onClick={() => download()}><FaFilePdf /> Download</Button>
    }
    if (type === 'storno') {
        bg = '#a625d9'; 
        border = 'border-violet';
        icon = <TiCancel className="text-violet" size={40} />
        headerText = "Stornorechnung";
        iconDate = new Date(data.x_eingangsdatum).toLocaleDateString('DE-de');
        leftColumnText = <><b>Rechnungsdatum</b><p>{new Date(data.x_eingangsdatum).toLocaleDateString('De-de')}</p></>
        rightColumnText = <><b>Abrechnungszeitraum</b><p>{new Date(data.x_abrechnungszeitraum_von).toLocaleDateString('DE-de')} - {new Date(data.x_abrechnungszeitraum_bis).toLocaleDateString('DE-de')}</p></>
        secondRowLeftText = <><b>Verbrauch gesamt</b><p>{data.x_verbrauch_gesamt} kWh</p></>
        secondRowRightText = <><b>Energiekosten netto</b><p>{Number(data.x_energiekosten_netto).toFixed(2)} €</p></>
        thirdRowLeftText = <Button className="btn-dark" onClick={() => download()}><FaFilePdf /> Download Storno</Button>
        thirdRowRightText = <Button className="btn-dark" onClick={() => download()}><FaFilePdf /> Download Abrechnung</Button>

    }
    if (type === 'mahnung') {
        bg = '#dc3545'; 
        border = 'border-danger';
        icon = <TiWarningOutline className="text-danger" size={40} />;
        headerText = "Mahnung";
        iconDate =  new Date(data.x_eingangsdatum).toLocaleDateString('DE-de');

        thirdRowLeftText = <Button className="btn-dark" onClick={() => download()}><FaFilePdf /> Download Mahnung</Button>
        thirdRowRightText = <Button className="btn-dark" onClick={() => download()}><FaFilePdf /> Download Abrechnung</Button>
    }
    if (type === 'ticket') {
        bg = 'cyan'; 
        color='black'; 
        border = 'border-cyan';
        icon =  <FaTicketAlt className="text-cyan" size={40} />;
        headerText = `Ticket ${data.name}`;
        iconDate = new Date(data.create_date).toLocaleDateString('DE-de');
        leftColumnText = <><b>Erstellt</b><p>{new Date(data.create_date).toLocaleDateString('DE-de')}</p></>
    }


    if (future) opacity = 0.4;

    
    
    // * handlers

    // function to pdf modal
    const openPdf = (id=data.id) => {
        setReadingLoading(true);
        API.client_timeline_download(type, id)
            .then(res => {
                let data = res.data;
                setPdfFile(data.file);
                setPdfModal(true);
                setReadingLoading(false);
            })
            .catch(err => {
                setReadingLoading(false);
            })
    };

    
    // file download handler
    const download = (id=data.id) => {
        setDownloadLoading(true);
        API.client_timeline_download(type, id)
            .then(res => {
                let data = res.data;
                const linkSource = `data:application/pdf;base64,${data.file}`;
                let fileName = data.filename;
                const downloadLink = document.createElement('a');

                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
                setDownloadLoading(false);
            })
            .catch(err => {
                setDownloadLoading(false);
            })
    }

    return (
        <>
        <div 
            className={type === "elvend"? "timeline-elv-end": type === "elvstart"? "timeline-elv-start" : "timeline-item"}
            style={{background: bg, opacity: opacity, color: color}}
        >
            <div className={left ? "tline-item-icon-left":"tline-item-icon"}>
                <div hidden={type === "elvstart" || type === "elvend"} className={`circle-icon ${border}`}>
                    {icon}
                </div>
            </div>
            <div className="tline-item-header">
                {headerText}
            </div>
            <div hidden={type === "elvstart" || type === "elvend"} className={left? "tline-item-date-left":"tline-item-date"}>
                {iconDate}
            </div>
            <div className="tline-item-body">
                <Row className="text-center align-items-center">
                    <Col xs="12" md="12" xl={rightColumnText !== false? "6":"12"} className={rightColumnText !== false? "border-right":""}>
                        {leftColumnText}
                    </Col>
                    <Col xs="12" md="12" xl="6" hidden={rightColumnText === false }>
                        {rightColumnText}
                    </Col>
                </Row>

                <Row className="mt-3 text-center align-items-center" hidden={secondRowLeftText === false}>
                    <Col xs="12" md="12" xl={secondRowRightText !== false? "6":"12"} className={secondRowRightText !== false? "border-right":""}>
                        {secondRowLeftText}
                    </Col>
                    <Col xs="12" md="12" xl="6" hidden={secondRowRightText === false}>
                        {secondRowRightText}
                    </Col>
                </Row>

                <Row className="mt-3 text-center align-items-center" hidden={thirdRowLeftText === false}>
                    <Col xs="12" md="12" xl={thirdRowRightText !== false? "6":"12"}>
                        {thirdRowLeftText}
                    </Col>
                    <Col xs="12" md="12" xl="6" hidden={thirdRowRightText === false}>
                        {thirdRowRightText}
                    </Col>
                </Row>
            </div>
        </div>
    <PdfModal show={pdfModal} setShow={setPdfModal} file={pdfFile} />
    </>
    )
}

export default TimelineItem;